<template>
  <v-app>
    <v-main>
      <GlobalSnackbar />
      <v-container class="fill-height">
        <v-row class="fill-height">
          <v-col class="login-page-left pa-15 ml-10">
            <LoginPageInfo />
          </v-col>
          <v-col class="login-page-right w-100">
            <slot></slot>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import GlobalSnackbar from "@/components/feedback/GlobalSnackbar.vue";
import LoginPageInfo from "@/views/login-view/LoginPageInfo.vue";

export default defineComponent({
  components: { LoginPageInfo, GlobalSnackbar },
});
</script>

<style scoped lang="scss">
.v-container {
  max-width: 100%;
  padding: 0;
  margin: 0;
}

.login-page-left {
  background-color: var(--white);
}

.login-page-right {
  background-color: var(--yellow);
  background-image: url("/assets/external-page-background.svg");
  background-position: bottom 0 right 0;
}
</style>
